import React from 'react'
import { BrowserRouter as Router, Routes,Route, Outlet} from "react-router-dom";
import { Navigate } from 'react-router-dom';

//main 
import InputLoginPage from '../../Caisse/loginPage'
import InputLandingPage from '../../Caisse/caisseLandingPage'
import UploadeCamionPage from '../../Caisse/Upload/updatePage';
import GConf from '../generalConf';

//Caisses
import CaisseSimple from "../../Caisse/Caisse/caisseSimple"; 
import CaisseStagiere from "../../Caisse/Caisse/caisseStagiere"; 
import CaisseRapide from "../../Caisse/Caisse/caisseRapide";

//Factures
import MesFactures from '../../Caisse/Factures/mesFactures';
import MesFacturesEnAttent from '../../Caisse/Factures/factureEnAttent';
import FactureInfo from '../../Caisse/Factures/factureInfo';
import EditFacture from '../../Caisse/Factures/editFacture';

//Factures
import Commandes from '../../Caisse/Commandes/mesFactures';
import CommandeInfo from '../../Caisse/Commandes/factureInfo';
import FinishCommande from '../../Caisse/Commandes/editFacture';

//Stock
import TicketPrix from "../../Caisse/Stock/ticketPrix";
import Stock from "../../Caisse/Stock/stockPage";
import StockList from '../../Caisse/Stock/stockList';
import ArticleInfo from '../../Caisse/Stock/ArticleInfo';
import CaissePannier from '../../Caisse/Stock/caissePannier';
import FamilleList from '../../Caisse/Stock/FamilleList';

//Client
import ClientsPage from "../../Caisse/Clients/client";
import ReglemmentClient from '../../Caisse/Clients/reglemmentClient';
import ClientList from '../../Caisse/Clients/clientList'; 

import AddTranche from "../../Caisse/Electro/ajouterTranche";
import ElectroClientListe from "../../Caisse/Electro/electroClientList";

//Recette
import Recette from "../../Caisse/Recette/recette";
import DepenseRecette from '../../Caisse/Recette/ajouterDepense';
import ImprimerRecette from '../../Caisse/Recette/imprimerRecette';
import AncienRecette from '../../Caisse/Recette/ancienRecette';
import MesOfflineFactures from '../../Caisse/Recette/mesFactures';
import OfflineTermineFacture from '../../Caisse/Recette/editFacture';
import CalculerFond from '../../Caisse/Recette/calculerFond';
import TotaleElectro from '../../Caisse/Recette/totaleElectro';




const RedirectingPage = () => {
    const CamionIsLogged = localStorage.getItem(`Magazin_Caisse_LocalD`);
    return (<>
        {
            CamionIsLogged ? <Navigate to='/C/L'  /> : <Navigate to='/C/logIn'  />
        } 
</>);}

const caisseRouter = () => (
    <Route path="C" exact element={<Outlet />} >
            <Route path="" exact element={<RedirectingPage />} />
            <Route path="logIn" exact element={<InputLoginPage />} />
            <Route path="L" exact element={<Outlet />} >
                    <Route path="" exact element={<InputLandingPage />} />
                    
                    <Route path="nv" exact element={<CaisseSimple />} />
                    <Route path="stagiere" exact element={<CaisseStagiere />} />
                    <Route path="cr" exact element={<CaisseRapide />} />
                    
                    <Route path="ft" exact element={<Outlet />} >
                        <Route path="" exact element={<MesFactures />} />
                        <Route path="info/:FID" exact element={<FactureInfo />} />
                        <Route path="edit/:FID" exact element={<EditFacture />} />
                    </Route>

                    <Route path="cd" exact element={<Outlet />} >
                        <Route path="" exact element={<Commandes />} />
                        <Route path="info/:CID" exact element={<CommandeInfo />} />
                        <Route path="edit/:CID" exact element={<FinishCommande />} />
                    </Route>

                    <Route path="sk" exact element={<Outlet />} >
                        <Route path="" exact element={<TicketPrix />} />
                        <Route path="stock" exact element={<Stock />} />
                        <Route path="Famille" exact element={< FamilleList />} />
                        <Route path="List/:genre" exact element={< StockList />} />
                        <Route path="Info/:code" exact element={<ArticleInfo />} />
                        <Route path="pannier" exact element={<CaissePannier />} />
                    </Route>

                    <Route path="cl" exact element={<Outlet />} >
                        <Route path="" exact element={<ClientList />} />
                        <Route path="info/:CLID" exact element={<ReglemmentClient />} />
                    </Route>

                    <Route path="el" exact element={<Outlet />} >
                        <Route path="" exact element={<ElectroClientListe />} />
                        <Route path="info/:CID" exact element={<AddTranche />} />
                         
                    </Route>

                    <Route path="rt" exact element={<Outlet />} >
                        <Route path="" exact element={<Recette />} />
                        <Route path="depenses" exact element={<DepenseRecette />} />
                        <Route path="imprimer" exact element={<ImprimerRecette />} />
                        <Route path="ancien" exact element={<AncienRecette />} />
                        <Route path="foff" exact element={<MesOfflineFactures />} />
                        <Route path="foff/termine/:FID" exact element={<OfflineTermineFacture />} />
                        <Route path="calculerfond" exact element={<CalculerFond />} />
                        <Route path="totaleelectro" exact element={<TotaleElectro />} />
                        <Route path="enAttent" exact element={<MesFacturesEnAttent />} />
                    </Route>

                    <Route path="up" exact element={<UploadeCamionPage />} />
            </Route>
    </Route>
)

export default caisseRouter 